import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Store } from '@ngrx/store';
import { Projects, Versions } from '@usimweb/core/models';
import * as fromStore from '@usimweb/state/store';
import { Dialog } from '../../container/dialog';

@Component({
  selector: 'copy-version-dialog',
  templateUrl: './copy-version-dialog.component.html',
  styleUrls: ['./copy-version-dialog.component.scss'],
  standalone: false,
})
export class CopyVersionDialogComponent extends Dialog implements OnInit {
  private version!: Versions;
  private version_uuid!: string;
  private project_uuid!: string;

  public projects!: Projects[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public obj: any,
    private dialogRef: MatDialogRef<CopyVersionDialogComponent>,
    private store: Store<fromStore.DashboardState>,
    private snackBar: MatSnackBar
  ) {
    super();
    this.version_uuid = obj.data.version;
  }

  ngOnInit(): void {
    this.store.dispatch(new fromStore.LoadProjects());
    this.store.dispatch(new fromStore.GetVersioByid(this.version_uuid));

    this.store.select(fromStore.getAllProjects).subscribe((projects) => {
      this.projects = projects;
    });
    this.store.select(fromStore.getVersionsById(this.version_uuid)).subscribe((version) => {
      this.version = version;
    });
  }

  public selectedProject(project: string) {
    this.project_uuid = project;
  }

  public save() {
    if (this.project_uuid) {
      const newVersion = {
        input_value: this.version.vela?.input_value,
        name: this.version.name,
        project: this.project_uuid,
      };
      this.store.dispatch(new fromStore.CreateVersion(newVersion));
      this.snackBar.open('Copied project...', 'OK', { duration: 2000 });
      this.dialogRef.close();
      return;
    }
    this.snackBar.open('Please select a Project...', 'OK', { duration: 5000 });
  }

  override close(): void {
    this.dialogRef.close();
  }
}
